// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H9bv6","placeholdersHeader":"styles_placeholdersHeader__21U3E","editorStyle":"styles_editorStyle__1O5nD","placeholdersBox":"styles_placeholdersBox__3Dt17"};